module.exports = __webpack_public_path__ + "img/undraw_air_support_wy1q.5821036c.svg";